<template>
  <page-error
    class="v-error-service-disabled"
    :message="$t('The admin panel is temporarily unavailable. Please try again in a few minutes.')"
    :title="$t('Service unavailable')"
  />
</template>

<script>
  import PageError from '@/common/components/PageError.vue';

  export default {
    name: 'ErrorServiceDisabled',
    components: {
      PageError
    }
  };
</script>
